
import storage from "./storage";


export const getList = (type) => {
    return getDICT(type).list
}
export const getValue = (type, key) => {
    const DICT = getDICT(type)
    const value = DICT.map[key]
    return value
}

export const getDICT = (type) => {
    const DICT = get()[type];
    return DICT ? DICT : {list: [], map: {}}
}
export const get = () => {
    const DICT = storage.getCache('DICT');
    return DICT ? DICT : {}
}